<template>
 

    <div class="row mb-3">
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{ i18n.t('tables.income.customer.title')
                            }} </b>:
                        <span v-if="income?.member_info">
                            {{ i18n.t('tables.income.customer.memberClub') }}
                        </span>
                        <span v-else>
                            {{ i18n.t('tables.income.customer.foreignMember') }}
                        </span>

                    </div>
                </div>
                <div v-if="income?.member_info?.name" class="col-md-12 mb-2">
                    <p class="timeline-content">
                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.name") }} </b>: {{
                            income?.member_info?.name }}
                    </p>
                </div> 
                <div v-if="income?.member_info?.matricule" class="col-md-12 mb-2">
                    <p class="timeline-content">
                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.matricule") }}
                        </b>:
                        <span class="actif">
                            {{ income?.member_info?.matricule }}
                        </span>
                    </p>
                </div>
                <div v-if="income?.member_info?.cin" class="col-md-12 mb-2">
                    <p class="timeline-content">
                        <b class="d-inline-block w-160">{{ i18n.t("tables.members.cin") }}
                        </b>
                        :<span class="actif">
                            {{ income?.member_info?.cin }}
                        </span>
                    </p>
                </div>
                <div v-if="!income?.member_info" class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{ i18n.t('tables.members.name') }} </b>:
                        {{
                            income?.memberName ?? '' }}
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{ i18n.t('tables.income.category_name') }}
                        </b> :
                        <span>{{ income?.service?.category?.name ?? '' }}</span>

                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{ i18n.t('tables.income.service_name') }}
                        </b>:
                        <span>{{ income?.service?.name ?? '' }} </span>
                        <span v-if="income?.service_type"> (<b> {{ income?.service_type ?? ''
                                }}</b>)</span>

                    </div>
                </div>
                <div v-if="income?.description" class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160">{{ i18n.t('tables.income.description') }}
                        </b> :
                        {{ income?.description ?? '' }}
                    </div>
                </div>
                <div v-if="income?.total_sessions" class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{ i18n.t('tables.income.total_sessions')
                            }} </b>:
                        <span>{{ income?.total_sessions ?? '' }}</span>


                    </div>
                </div>
                <div v-if="income?.total_sessions" class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{
                            i18n.t('tables.income.consumed_sessions') }} </b>:
                        <span>{{ income?.consumed_sessions ?? 0 }}</span>
                    </div>
                </div>
                <div v-if="income?.total_sessions" class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{
                            i18n.t('tables.income.remaining_sessions') }} </b>:
                        <span>{{ income?.remaining_sessions ?? 0 }}</span>

                    </div>
                </div>
               

               


            </div>
        </div>
        <div class="col-md-6">

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160">{{ i18n.t('tables.income.date') }}
                        </b> :
                        {{ formatDate(income?.date) }}
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{ i18n.t('tables.income.total_amount')
                            }}
                        </b> :
                        {{ income?.total_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160">{{
                            i18n.t('tables.income.total_amount_paid')
                            }}
                        </b> :
                        {{ income?.total_amount_paid ?? 0 }} {{ i18n.t('symbole.currency.mad')
                        }}
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group mb-1 mt-1">
                        <b class="d-inline-block w-160"> {{
                            i18n.t('tables.income.remaining_amount')
                            }}
                        </b> :
                        {{ income?.remaining_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                    </div>
                </div>

            </div>

        </div>



    </div>

</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
/*Components*/


/*plugins*/
import i18n from "@/i18n/index"
/*composables & states */
import { singleIncome } from "@/shared/state";
import { useGlobal } from "@/composables/global/useGlobal";
import { usePermission } from "@/composables/auth/usePermission";
export default defineComponent({
    components: {},
    name: "info-income",


    setup() {
        //const { income } = toRefs(props);
        const { formatDate } = useGlobal();
        const { hasPermission } = usePermission();




        const income = computed(() => singleIncome.data);


        return {
            income,
            formatDate,
            hasPermission,
            i18n,
        };
    },
});
</script>
